module.exports = __webpack_public_path__ + "img/GHS-pictogram-silhouette.8405989f.png";